//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import halfNHalfCustomizer from '../../../common/mixins/customizer/halfNHalfCustomizer'

export default {
  name: 'HalfNHalf',
  mixins: [halfNHalfCustomizer],
  head () {
    return {
      title: this.$getPageTitle(this.currentItem ? this.$capitalize(this.currentItem.product_type + ' - ' + this.currentItem.name) : 'halfNHalfCustomizer')
    }
  },
  computed: {
    availableBases () {
      if (this.selectedSize) {
        return this.bases.filter(base => !!base.sizes.find(size => size.size === this.selectedSize) && base.slug !== 'gluten-free')
      }
      return this.bases
    }
  }
}
